module.exports = __webpack_public_path__ + "img/search.4160d471.svg";